import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import BigPlayButton from "core/components/BigPlayButton/BigPlayButton";
import ShortySeekBar from "./ShortySeekBar";
import ShortyControlPanel from "./ShortyControlPanel";
import ShortyContentInfo from "./ShortyContentInfo";
import { CloseRouteDialogButton } from "arena/components/RouteDialog";

export default function ShortyVideoOverlay({
  mainVideoRef,
  activeVideoData,
  videoState,
  videoActions,
  activeIndex,
  contentsLength,
  onNavigate,
  onOpenComments,
}) {
  if (!mainVideoRef.current) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10, // Контролы поверх видео (видео имеет zIndex: 0)
      }}
    >
      {/* BigPlayButton с включенными кликами */}
      <Box
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 30,
        }}
      >
        <BigPlayButton
          videoState={{
            ...videoState,
            // Приводим статус к ожидаемым значениям для BigPlayButton
            status: videoState.status === "playing" ? "playing" : "paused",
          }}
          onClick={() => {
            const isActuallyPlaying =
              mainVideoRef.current && !mainVideoRef.current.paused;

            if (isActuallyPlaying) {
              videoActions.pause();
            } else {
              videoActions.play();
            }
          }}
        />
      </Box>

      {/* Кнопка закрытия route dialog - всегда показываем */}
      <CloseRouteDialogButton />

      {/* Информация о контенте - только если есть данные */}
      {activeVideoData && (
        <Box
          sx={{
            position: "absolute",
            bottom: 20, // Над seek bar и control panel
            left: 16,
            right: 16,
            zIndex: 20,
            pointerEvents: "auto", // Разрешаем клики для диалога
          }}
        >
          <ShortyContentInfo
            content={activeVideoData.content}
            hideShortyTitle={activeVideoData.content.hideShortyTitle}
          />
        </Box>
      )}

      {/* ShortySeekBar - полоса прогресса */}
      <div
        style={{
          position: "absolute",
          bottom: -14, // Над ShortyControlPanel
          left: 0,
          right: 0,
        }}
      >
        <ShortySeekBar
          key={activeVideoData?.content?.id || "no-content"} // Сбрасываем компонент при смене видео
          videoState={videoState}
          videoActions={videoActions}
        />
      </div>

      {/* ShortyControlPanel с включенными кликами - только если есть данные */}
      {activeVideoData && (
        <div>
          <ShortyControlPanel
            content={activeVideoData.content}
            videoState={videoState}
            videoActions={videoActions}
            videoElement={mainVideoRef.current}
            onPrevious={(event) => {
              event.preventDefault();
              event.stopPropagation();
              event.target.blur();
              onNavigate("previous");
            }}
            onNext={(event) => {
              event.preventDefault();
              event.stopPropagation();
              event.target.blur();
              onNavigate("next");
            }}
            canGoPrevious={activeIndex > 0}
            canGoNext={activeIndex < contentsLength - 1}
            showThumbnail={false}
            onOpenComments={onOpenComments}
          />
        </div>
      )}
    </div>
  );
}

ShortyVideoOverlay.propTypes = {
  mainVideoRef: PropTypes.object.isRequired,
  activeVideoData: PropTypes.object,
  videoState: PropTypes.object.isRequired,
  videoActions: PropTypes.object.isRequired,
  activeIndex: PropTypes.number.isRequired,
  contentsLength: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onOpenComments: PropTypes.func.isRequired,
};
